/* tslint:disable */
/* eslint-disable */
/**
 * Live CSV Data Import Plugin
 * Plugin to handle CSV imported CSV files
 *
 * The version of the OpenAPI document: 1.23.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileMetadata
 */
export interface FileMetadata {
    /**
     * 
     * @type {boolean}
     * @memberof FileMetadata
     */
    allowReplay?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileMetadata
     */
    disabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FileMetadata
     */
    end?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    fileSize?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    fileType?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    indexColumn?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    indexFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    indexUOM?: string;
    /**
     * 
     * @type {number}
     * @memberof FileMetadata
     */
    lastModified?: number;
    /**
     * 
     * @type {number}
     * @memberof FileMetadata
     */
    lineCount?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    logName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    logType?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof FileMetadata
     */
    mnemonics?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof FileMetadata
     */
    nullValues?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    protocolName?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FileMetadata
     */
    remaps?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    rigEventType?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    rigName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    sourceKind?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    sourceName?: string;
    /**
     * 
     * @type {number}
     * @memberof FileMetadata
     */
    start?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    timezone?: string;
    /**
     * 
     * @type {number}
     * @memberof FileMetadata
     */
    timezoneOffset?: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    uid?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    uidLog?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    uidRig?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    uidWell?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    uidWellbore?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileMetadata
     */
    units?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FileMetadata
     */
    unitsOnHeader?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    uploadedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    wellEventType?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    wellName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    wellboreEventType?: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    wellboreName?: string;
}

/**
 * Check if a given object implements the FileMetadata interface.
 */
export function instanceOfFileMetadata(value: object): value is FileMetadata {
    return true;
}

export function FileMetadataFromJSON(json: any): FileMetadata {
    return FileMetadataFromJSONTyped(json, false);
}

export function FileMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'allowReplay': json['allowReplay'] == null ? undefined : json['allowReplay'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
        'end': json['end'] == null ? undefined : json['end'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
        'indexColumn': json['indexColumn'] == null ? undefined : json['indexColumn'],
        'indexFormat': json['indexFormat'] == null ? undefined : json['indexFormat'],
        'indexUOM': json['indexUOM'] == null ? undefined : json['indexUOM'],
        'lastModified': json['lastModified'] == null ? undefined : json['lastModified'],
        'lineCount': json['lineCount'] == null ? undefined : json['lineCount'],
        'logName': json['logName'] == null ? undefined : json['logName'],
        'logType': json['logType'] == null ? undefined : json['logType'],
        'mnemonics': json['mnemonics'] == null ? undefined : new Set(json['mnemonics']),
        'nullValues': json['nullValues'] == null ? undefined : new Set(json['nullValues']),
        'path': json['path'] == null ? undefined : json['path'],
        'protocolName': json['protocolName'] == null ? undefined : json['protocolName'],
        'remaps': json['remaps'] == null ? undefined : json['remaps'],
        'rigEventType': json['rigEventType'] == null ? undefined : json['rigEventType'],
        'rigName': json['rigName'] == null ? undefined : json['rigName'],
        'sourceKind': json['sourceKind'] == null ? undefined : json['sourceKind'],
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'start': json['start'] == null ? undefined : json['start'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'timezoneOffset': json['timezoneOffset'] == null ? undefined : json['timezoneOffset'],
        'uid': json['uid'] == null ? undefined : json['uid'],
        'uidLog': json['uidLog'] == null ? undefined : json['uidLog'],
        'uidRig': json['uidRig'] == null ? undefined : json['uidRig'],
        'uidWell': json['uidWell'] == null ? undefined : json['uidWell'],
        'uidWellbore': json['uidWellbore'] == null ? undefined : json['uidWellbore'],
        'units': json['units'] == null ? undefined : json['units'],
        'unitsOnHeader': json['unitsOnHeader'] == null ? undefined : json['unitsOnHeader'],
        'uploadedBy': json['uploadedBy'] == null ? undefined : json['uploadedBy'],
        'wellEventType': json['wellEventType'] == null ? undefined : json['wellEventType'],
        'wellName': json['wellName'] == null ? undefined : json['wellName'],
        'wellboreEventType': json['wellboreEventType'] == null ? undefined : json['wellboreEventType'],
        'wellboreName': json['wellboreName'] == null ? undefined : json['wellboreName'],
    };
}

export function FileMetadataToJSON(json: any): FileMetadata {
    return FileMetadataToJSONTyped(json, false);
}

export function FileMetadataToJSONTyped(value?: FileMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowReplay': value['allowReplay'],
        'disabled': value['disabled'],
        'end': value['end'],
        'fileName': value['fileName'],
        'fileSize': value['fileSize'],
        'fileType': value['fileType'],
        'indexColumn': value['indexColumn'],
        'indexFormat': value['indexFormat'],
        'indexUOM': value['indexUOM'],
        'lastModified': value['lastModified'],
        'lineCount': value['lineCount'],
        'logName': value['logName'],
        'logType': value['logType'],
        'mnemonics': value['mnemonics'] == null ? undefined : Array.from(value['mnemonics'] as Set<any>),
        'nullValues': value['nullValues'] == null ? undefined : Array.from(value['nullValues'] as Set<any>),
        'path': value['path'],
        'protocolName': value['protocolName'],
        'remaps': value['remaps'],
        'rigEventType': value['rigEventType'],
        'rigName': value['rigName'],
        'sourceKind': value['sourceKind'],
        'sourceName': value['sourceName'],
        'start': value['start'],
        'timezone': value['timezone'],
        'timezoneOffset': value['timezoneOffset'],
        'uid': value['uid'],
        'uidLog': value['uidLog'],
        'uidRig': value['uidRig'],
        'uidWell': value['uidWell'],
        'uidWellbore': value['uidWellbore'],
        'units': value['units'],
        'unitsOnHeader': value['unitsOnHeader'],
        'uploadedBy': value['uploadedBy'],
        'wellEventType': value['wellEventType'],
        'wellName': value['wellName'],
        'wellboreEventType': value['wellboreEventType'],
        'wellboreName': value['wellboreName'],
    };
}

